import { Telemetria } from "./Telemetria";

export class Agente {
  icon?: string;
  id: string;
  uuid?: string;
  tipo?: string
  lat?: any;
  lng?: any;
  label?: string;
  draggable?: boolean;
  andamentos?: any;
  unidade_id?: string;
  telemetria_id?: string;
  created_at?: string;
  agentes_status?: any;
  checked?: boolean;

  user_id?: string;
  matricula?: string;
  matricula_ergon?: string;
  sexo?: string;
  grupo_sanguineo?: string;

  idUsuario?: string;
  hrTurma?: string;
  nmTurma?: string;
  nmEscala?: string;
  nome_completo?: string;
  nome_guerra?: string;
  telefone?: string;
  data_nascimento?: string;
  data_admissao?: string;
  categoria?: string;
  situacao?: string;
  lotacao?: string;
  sigla?: string;
  cargo?: string;
  nivel?: string;
  posto?: string;
  turma?: string;
  escala?: string;
  tipo_servico?: string;
  tipo_categoria?: string;
  logado?: string;
  nome_status?: string;
  telefone_dispositivos?: string;
  conta_google_dispositivos?: string;

  endereco?: string;
  unidade?: string;
  idServidor?: string;
  dscEstado?: string;
  status?: number;
  pronto?: boolean;
  foto?: string;
  telemetria_update?: string;
  telemetrias?: Telemetria | null;
  panico?:string;
  panico_horario?:string;
  public animation?: string;
  public isOpen?: any;


}



// WEBPACK FOOTER //
// ./src/app/models/agente.ts